import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {getAgentHostsV3} from '../services/agent.http'

export const useGetAgentHostsV3 = (enabled = true) => {
    return useQuery({
        queryKey: [QUERY_KEYS.agentRookiesV3],
        queryFn: () => getAgentHostsV3(),
        enabled
    })
}
